module.exports = envConfig;